export default "<div class=\"wrapper\" [ngClass]=\"classes\">\n  <ng-content></ng-content>\n</div>\n"